export const TICKET_STATES = [
  { label: 'À faire', key: 'todo', style: 'bg-secondary text-white' },
  { label: 'En cours', key: 'inprogress', style: 'bg-primary text-white' },
  { label: 'Bloqué', key: 'bloqued', style: 'bg-thirdary text-white' },
  { label: 'Terminé', key: 'done', style: 'bg-gray text-black' }
];